import { map } from './_context.js';
import { closeInfoWindow } from './_infowindow.js';

export function setIconInHtmlMarker(icon, htmlMarker) {
    htmlMarker.icon = icon;
    if (htmlMarker.div) {
        htmlMarker.div.innerHTML = htmlMarker.pin + (icon ? icon : '');

        if (htmlMarker.div.childNodes.length > 1) {
            if (htmlMarker.div.childNodes.item(1).nodeName == 'svg') {
                htmlMarker.div.childNodes.item(1).classList.add('carte-pin__icon');
            } else {
                htmlMarker.div.innerHTML = htmlMarker.pin;
            }
        }
        if (htmlMarker.div.childNodes[0] && htmlMarker.div.childNodes[0].nodeName == 'svg') {
            htmlMarker.div.childNodes[0].classList.add('carte-pin__marker');
            const paths = htmlMarker.div.childNodes[0].getElementsByTagName('path');
            for (var i = 0; i < paths.length; i++) {
                paths[i].style.fill = htmlMarker.color;
            }
            const circles = htmlMarker.div.childNodes[0].getElementsByTagName('circle');
            for (var j = 0; j < circles.length; j++) {
                circles[j].style.fill = htmlMarker.color;
            }
        }
    }
}

/** Set by {@link initHtmlMarkerClass} after the Maps JS API has loaded (cannot extend OverlayView earlier). */
export let HtmlMarker;

export function initHtmlMarkerClass() {
    if (HtmlMarker) {
        return;
    }
    HtmlMarker = class extends google.maps.OverlayView {
        constructor(position, icon, title, color, pin = null) {
            super();
            this.position = position;
            this.icon = icon;
            this.title = title;
            this.color = color;
            this.pin = pinSVG;
            if (pin) {
                this.pin = pin;
            }
        }

        onAdd() {
            const panes = this.getPanes();
            this.div = document.createElement('div');
            this.div.style.borderStyle = 'none';
            this.div.style.borderWidth = '0px';
            this.div.style.position = 'absolute';
            this.div.classList.add('carte-pin');
            setIconInHtmlMarker(this.icon, this);
            panes.markerLayer.appendChild(this.div);
        }

        draw() {
            const projection = this.getProjection();
            const point = projection.fromLatLngToDivPixel(this.position);
            if (point === null) {
                return;
            }
            this.div.style.transform = `translate(${point.x}px, ${point.y}px)`;
        }

        onRemove() {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                delete this.div;
            }
        }

        hide() {
            if (this.div) {
                this.div.style.visibility = 'hidden';
            }
        }

        show() {
            if (this.div) {
                this.div.style.visibility = 'visible';
            }
        }

        toggle() {
            if (this.div) {
                if (this.div.style.visibility === 'hidden') {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }

        toggleDOM(mapInstance) {
            if (this.getMap()) {
                this.setMap(null);
            } else {
                this.setMap(mapInstance);
            }
        }
    };
}

export function adjustMarkerVisibility() {
    closeInfoWindow(true);
    if (actMapData.length) {
        actMapData.forEach(function (e) {
            let forceShow = false;
            let el = document.getElementById('venue-card-' + e.id);
            if (el && el.classList.contains('map-venue-card__is-active')) {
                forceShow = true;
            }
            if (e.marker) {
                if (e.marker.getMap() || forceShow) {
                    if (!e.htmlMarker.getMap()) {
                        e.htmlMarker.setMap(map);
                    }
                } else {
                    if (e.htmlMarker.getMap()) {
                        e.htmlMarker.setMap(null);
                    }
                }
            }
        });
    }
}
